import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface ColumnsProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Columns: React.FC<ColumnsProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [columns, setColumns] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Exterior Features']?.['Columns'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Exterior Features': { ...s.values?.['Exterior Features'], Columns: v } } })
    );
    const label = 'Columns';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={columns}
                />
            ) : (
                <TextBox
                    value={columns ?? ''}
                    onChange={(value) => setColumns(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
